import { ResellerLevel, useGetResellers } from "modules/resellers";
import { useMemo, useState } from "react";
import { Controller } from "react-hook-form";
import { Option, PersonInfo, Select } from "ui";

import { InfluencerFieldProps } from "../CouponForm.types";

import styles from "../CouponForm.module.scss";

const InfluencerField = ({ control }: InfluencerFieldProps) => {
  const [filterValue, setFilterValue] = useState("");

  const { resellers, isLoading } = useGetResellers({
    search: filterValue,
    levels: ResellerLevel.Influencer,
    isDeleted: false,
    page: 1,
    take: 20
  });

  const selectOptions: Option[] = useMemo(() => {
    return (
      resellers?.map((reseller) => ({
        label: (
          <PersonInfo
            wrapperClassName={styles.form_influencerField_personlabel}
            dimensions={{ width: 25, height: 25, borderRadius: "50%" }}
            personName={`${reseller.firstname} ${reseller.lastname}`}
            image={reseller.image}
          />
        ),
        value: reseller.id
      })) || []
    );
  }, [resellers]);

  return (
    <Controller
      control={control}
      name="influencerIdWhoGivenInfluencerCoupon"
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <Select
          label="Influencer"
          options={selectOptions}
          value={value}
          errorMessage={error?.message}
          onChange={(nextValue) => {
            onChange(nextValue);
          }}
          withFilterInput
          onFilterInputChange={setFilterValue}
          isOptionsLoading={isLoading}
        />
      )}
    />
  );
};

export default InfluencerField;
